import * as TicketExample from './components/TicketExample.css';
export default { TicketExample };
